import {
  Col,
  Card,
  Button,
  ButtonGroup,
  Input,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import download from "../../../assets/images/download.png";
import statusimage from "../../../assets/images/status.png";
import rightarrow from "../../../assets/images/chevron-right.png";
import search from "../../../assets/images/search.png";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import EditForm from "../EditForm/EditForm";
import MoveProcessingStatus from "../MoveProcessingStatus/MoveProcessingStatus";
import * as moment from "moment";
import "./ProcessingTable.css";
import PaginationTable from "../PaginationTable";
import axiosInstance from "../../../helpers/axios";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../../actions/user.actions";
import SendSms from "../SendSms/SendSms";
import WarningIcon from "@mui/icons-material/Warning";
import InstituteAutocomplete from "../../status/ProjectTable/InstituteSearch";
import { ApplicationStatusEnum } from "../../../data";
import { handleExcelDownload } from "../../../utils/excelDownload";
import DangerousIcon from "@mui/icons-material/Dangerous";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import useProcessingData from "../../../hooks/useProcessingData";
import alerticon from "../../../assets/images/alertIcon.png";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { appContextConstants } from '../../../constants/appContext.constants';
import SourceBadge from "../../shared/SourceBadge/SourceBadge";


const ProcessingTable = () => {
  const processstate = useSelector((state) => state?.Inprogress?.res);
  const datestate = useSelector((state) => state.Datefilter?.res);
  const usersearchstate = useSelector(
    (state) => state?.UserSearch?.res?.data?.data
  );

  const decode = useCurrentUser();
  const user = null;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const status = ApplicationStatusEnum.InProcess;

  const defaultFundSource =
    decode.role === "institute_user" ||
    decode?.role === "institute_admin" ||
    decode?.role === "channel_user"
      ? "" : decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
      ? "BJY"
      : decode?.role === "institute_cra" && decode?.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e"
      ? "FIB"
      : "GBP";

  const {
    tableData,
    currentPage,
    rowsPerPage,
    totalFetchRows,
    isLoading,
    filterDateFrom,
    filterDateTo,
    instituteId,
    instituteName,
    selectedCRA,
    activePage,
    fundSourceSelected,
    fundSourceArray,

    setFilterDateFrom,
    setFilterDateTo,
    setInstituteId,
    setInstituteName,
    setSelectedCRA,
    setCurrentPage,

    handlePageChange, // page number change
    handleRowsPerPageChange, // 15 / 50 / 100 / 500
    handleSearch, // Search Results
    clearFilters,
    handleCRAChange,
    handleFundSourceFilter,
    productTypeSelected
  } = useProcessingData({
    status,
    user,
    defaultFundSource,
    dependencies: {
      processstate,
      datestate,
      usersearchstate,
    },
  });

  const valid = (current) =>
    filterDateFrom ? current.isAfter(filterDateFrom) : true;

  const isPersonalLoanSelected = productTypeSelected === "2";

  const handleDownloadList = () => {
    handleExcelDownload({
      status: status,
      instituteId: decode.instituteId ? decode.instituteId : instituteId,
      fromDate: filterDateFrom,
      toDate: filterDateTo,
      productType:
        productTypeSelected && productTypeSelected !== "all"
          ? Number(productTypeSelected)
          : undefined,
      user: user,
      downloadIcon: download,
      buttonId: "downloadButton",
      buttonStyles: {
        width: "90px",
        marginLeft: "150px",
      },
      additionalData: {
        fundSource: fundSourceSelected,
      },
    });
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString("en-IN");
  }

  // ---------- navigation / row handlers (unchanged logic) ----------

  const handleUser = (event) => {
    const Id = event.userId;
    const applId = event.applicationId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      selectedUserId: event.userId,
      userId: event.userId,
      coapplicantId: event?.coapplicantId
        ? typeof event?.coapplicantId === "string"
          ? event?.coapplicantId
          : event?.coapplicantId[0]
        : "",
      appId: applId,
    }});
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));
    sessionStorage.setItem("fromProcessingTable", "true");
    navigate("/status/Process/profile", {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "In Process",
        coapplicants: event?.coapplicants,
        name: event?.name,
        noBankStatement: event?.noBankStatement,
        noVerification: event?.noVerification,
      },
    });
  };

  const handleCoApp = (event, coAppUserId) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: coAppUserId } });
    const Id =
      event?.coapplicants?.length > 1
        ? coAppUserId
        : event?.coapplicantId
        ? typeof event?.coapplicantId === "string"
          ? event?.coapplicantId
          : event?.coapplicantId[0]
        : "";
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));
    sessionStorage.setItem("fromProcessingTable", "true");
    navigate("/status/Process/profile", {
      state: {
        id: 1,
        profileId: Id,
        clickEvent: "coapp",
        applicantId: event.userId,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "In Process",
        coapplicants: event?.coapplicants,
        name: event?.name,
        noBankStatement: event?.noBankStatement,
        noVerification: event?.noVerification,
      },
    });
  };

  const handleApplicationProfile = (item) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      coappId: item?.coapplicantId,
      userId: item?.userId,
      appId: item?.applicationId,
    }});
    // const urlForApplicationDetails = `/admin/application/application-profile?applicationId=${sessionStorage.getItem(
    //   "appId"
    // )}`;
    // const urlForBankSelfie = `/integrations/application-profile?applicationId=${sessionStorage.getItem(
    //   "appId"
    // )}`;
    // const getEmiUrl = `/emis?applicationId=${sessionStorage.getItem("appId")}`;
    // const getActivityUrl = `/audit?applicationId=${sessionStorage.getItem(
    //   "appId"
    // )}`;
    // dispatch(
    //   userActions.fetchUrlforApplicationdetails(urlForApplicationDetails, user),
    //   []
    // );
    // dispatch(
    //   userActions.fetchUrlforbankselfie(urlForBankSelfie, user),
    //   []
    // );
    // dispatch(userActions.fetchEmiUrl(getEmiUrl, user), []);
    // dispatch(userActions.getActivity(getActivityUrl, user));
    sessionStorage.setItem("fromProcessingTable", "true");
    navigate("/status/Process/appProfile", { state: item });
  };

  const handleCIBIL = (event) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: event.userId } });

    const Id = event.userId;
    const profileUrl = `/summary/user?id=${Id}&applicationId=${event.applicationId}&status=In Process`;

    dispatch(userActions.fetchHandleuser(profileUrl, user), []);

    const ckycUrl = `/ckyc/details?userId=${Id}`;
    const digilockerUrl = `/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
    const panUrl = `/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
    const bankSelfieUrl = `/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
    const uploadedFileUrl = `/users/documents/admin?userId=${Id}`;
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    const urlForBankSelfie = `/integrations/application-profile?applicationId=${event.applicationId}`;
    const urlCIBIL = `/cibil/report?userId=${Id}`;
    const getFoirRefUrl = `/admin/application/additional-info?applicationId=${event.applicationId}`;
    const urlIncomeProfile = `/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${event.applicationId}`;

    dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile, user));
    dispatch(userActions.getCkycDetails(ckycUrl, user));
    dispatch(userActions.getCibilDetails(urlCIBIL));
    dispatch(userActions.getPanStatus(panUrl));
    dispatch(userActions.getBankSelfieDetails(bankSelfieUrl, user));
    dispatch(userActions.getDigiLocker(digilockerUrl, user));
    dispatch(userActions.getProfileDetails(profileUrl));
    dispatch(userActions.getUploadedFiles(uploadedFileUrl, user));
    dispatch(userActions.getActivity(getActivityUrl, user));
    dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
    dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), []);
    sessionStorage.setItem("fromProcessingTable", "true");
    navigate("/status/Process/profile", {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        viaCibil: true,
        dir: "In Process",
        coapplicants: event?.coapplicants,
        name: event?.name,
        noBankStatement: event?.noBankStatement,
        noVerification: event?.noVerification,
      },
    });
  };

  const handleCoAppCIBIL = (event, coAppUserId) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: coAppUserId } });
    const Id =
      event?.coapplicants?.length > 1
        ? coAppUserId
        : event.coapplicantId
        ? typeof event.coapplicantId === "string"
          ? event.coapplicantId
          : event.coapplicantId[0]
        : "";
    const applId = event.applicationId;

    const urlProfile = `/summary/coapplicant?id=${Id}&status=In Process`;

    dispatch(userActions.fetchHandlcoappuser(urlProfile, user, navigate, applId, Id), []);

    const ckycUrl = `/ckyc/details?userId=${Id}`;
    const digilockerUrl = `/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
    const panUrl = `/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
    const bankSelfieUrl = `/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
    const uploadedFileUrl = `/users/documents/admin?userId=${Id}`;
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    const urlForBankSelfie = `/integrations/application-profile?applicationId=${event.applicationId}`;
    const getFoirRefUrl = `/admin/application/additional-info?applicationId=${event.applicationId}`;
    const urlIncomeProfile = `/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${event.applicationId}`;
    const urlCIBIL = `/cibil/report?userId=${Id}`;

    dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile, user));
    dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
    dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), []);
    dispatch(userActions.getCkycDetails(ckycUrl, user));
    dispatch(userActions.getCibilDetails(urlCIBIL));
    dispatch(userActions.getPanStatus(panUrl));
    dispatch(userActions.getBankSelfieDetails(bankSelfieUrl, user));
    dispatch(userActions.getDigiLocker(digilockerUrl, user));
    dispatch(userActions.getProfileDetails(urlProfile));
    dispatch(userActions.getUploadedFiles(uploadedFileUrl, user));
    dispatch(userActions.getActivity(getActivityUrl, user));
    sessionStorage.setItem("fromProcessingTable", "true");
    navigate("/status/Process/profile", {
      state: {
        id: 1,
        profileId: Id,
        clickEvent: "coapp",
        applicantId: event.userId,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        viaCibil: true,
        dir: "In Process",
        coapplicants: event?.coapplicants,
        name: event?.name,
        noBankStatement: event?.noBankStatement,
        noVerification: event?.noVerification,
      },
    });
  };

  const showErrorApplicant = (uid, appid, error) => {
    const profileUrl = `/summary/user?id=${uid}&applicationId=${appid}&status=In Review`;
    dispatch(userActions.getProfileDetails(profileUrl));

    dispatch({ type: appContextConstants.SET_REFETCH_CONTEXT, payload: { refetchUid: uid, refetchAppId: appid } });

    const Id = uid;
    const urlCIBIL = `/cibil/report?userId=${Id}`;

    axiosInstance
      .get(urlCIBIL)
      .then(() => {})
      .catch(() => {
        alert("Error While Fetching CIBIL");
      });
  };

  const showErrorCoApplicant = (uid, appid, error) => {
    const profileUrl = `/summary/coapplicant?id=${uid}&status=In Review`;
    dispatch(userActions.getProfileDetails(profileUrl));

    dispatch({ type: appContextConstants.SET_REFETCH_CONTEXT, payload: { refetchUid: uid, refetchAppId: appid } });

    const Id = uid;
    const urlCIBIL = `/cibil/report?userId=${Id}`;

    axiosInstance
      .get(urlCIBIL)
      .then(() => {})
      .catch(() => {
        alert("Error While Fetching CIBIL");
      });
  };
  const isFibInfoVisible =
    fundSourceSelected === "FIB" &&
    (decode?.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" ||
      decode?.role === "admin" || decode?.role === "crsa" || decode?.role === "crm" || decode?.role == "cra" || decode?.role === "institute_cra");

  const [fibInfoModalOpen, setFibInfoModalOpen] = useState(false);
  const [fibInfoLoading, setFibInfoLoading] = useState(false);
  const [fibTenureData, setFibTenureData] = useState([]);

  const handleFibInfoClick = (item) => {
    setFibInfoModalOpen(true);
    setFibInfoLoading(true);
    setFibTenureData([]);

    const url = `/fibe/available-tenures?userId=${item.userId}&applicationId=${item.applicationId}`;
    const token = sessionStorage.getItem("user");
    axiosInstance
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setFibTenureData(res?.data?.data?.sanctionLimitTenure || []);
      })
      .catch(() => {
        setFibTenureData([]);
      })
      .finally(() => {
        setFibInfoLoading(false);
      });
  };

  const toggleFibInfoModal = () => setFibInfoModalOpen((open) => !open);

  // wrapper for PaginationTable (page numbers)
  const paginate = (pageNumber) => {
    handlePageChange(pageNumber);
  };

  // wrapper for rows-per-page in PaginationTable
  const handlepageChangeLocal = (number) => {
    handleRowsPerPageChange(number);
  };

  // -------------------- RENDER --------------------

  if (!tableData) {
    return <div>....Loading</div>;
  }

  return (
    <>
    <Card
      className="card"
      style={{
        width: "100%",
        height: "100%",
      }}
    >
        <CardBody>
          <div style={{ display: "flex" }}>
            <p style={{ display: "flex", alignItems: "center" }}>
              <img src={statusimage} alt="" />
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  marginLeft: "10px",
                  fontSize: "14px",
                }}
              >
                status
              </span>
              <span style={{ marginLeft: "20px", marginBottom: "3px" }}>
                <img
                  style={{ height: "18px", width: "14px" }}
                  src={rightarrow}
                  alt=""
                />
              </span>
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  marginLeft: "10px",
                  fontSize: "14px",
                  color: "#D32028",
                }}
              >
                In Process
              </span>
            </p>

            {decode?.role !== "institute_user" &&
            decode?.role !== "institute_admin" &&
            decode.role !== "channel_user" &&
            decode?.clientId !== "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"&&
              !isPersonalLoanSelected   ? (
              <div style={{ paddingLeft: "30%" }}>
                <ButtonGroup style={{ border: "0.2px solid #ccc" }}>
                  {/* <Button
                    onClick={() =>
                      handleFundSourceFilter("", filterDateFrom, filterDateTo)
                    }
                    style={{
                      color: fundSourceSelected === "" ? "white" : "black",
                      backgroundColor:
                        fundSourceSelected === "" ? "#D22129" : "white",
                      borderRight: "1px solid black",
                    }}
                  >
                    All
                  </Button> */}
                  {fundSourceArray
                    ?.filter(
                      (item) =>
                        item?.fundSource &&
                        item.fundSource !== "undefined" &&
                        ["GBP", "FIB", "AVN"].includes(item.fundSource)
                    )
                    .map((item, index, array) => {
                      const isSelected =
                        fundSourceSelected === item.fundSource;
                      let selectedColor = "white";
                      if (isSelected && item.fundSource === "GBP") {
                        selectedColor = "#fee2e4";
                        } else if (isSelected && item.fundSource === "FIB") {
                          selectedColor = "#B3E5FC";
                        }else if (isSelected && item.fundSource === "AVN") {
                        selectedColor = "#ECFDF3";
                      }

                      return (
                        <Button
                          key={item.fundSource}
                          onClick={() =>
                            handleFundSourceFilter(
                              item.fundSource,
                              filterDateFrom,
                              filterDateTo
                            )
                          }
                          style={{
                            color: isSelected ? "#D22129" : "black",
                            backgroundColor: selectedColor,
                            borderRight:
                              index !== array.length - 1
                                ? "1px solid black"
                                : undefined,
                          }}
                        >
                          {item.fundSource}
                          <span
                            style={{
                              marginLeft: "10px",
                              color: "white",
                              backgroundColor: "#D22129",
                              padding: "5px 8px",
                              borderRadius: "1rem",
                              textAlign: "center",
                              fontSize: "0.75rem",
                            }}
                          >
                            {item.count}
                          </span>
                        </Button>
                      );
                    })}
                </ButtonGroup>
              </div>
            ) : null}
          </div>

          <Row>
            <div style={{ display: "flex", flex: "wrap" }}>
              <Col sm="12" md="10" lg="3">
                <div
                  style={{
                    height: "23px",
                    marginRight: "10px",
                    fontFamily: "Inter",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {decode.role === "institute_admin" ||
                  decode.role === "institute_user" ||
                  decode.role === "institute_cra" ? (
                    <Input
                      type="text"
                      id="userSearch"
                      value={decode.instituteName}
                      readOnly
                      disabled
                      placeholder={"Merchant Name"}
                      style={{
                        fontSize: "0.8vw",
                        paddingLeft: "26px",
                        fontFamily: "Inter",
                        backgroundImage: `url(${search})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "5px center",
                        backgroundSize: "15px 15px",
                        paddingRight: "5px",
                        borderColor: "#cccccc",
                        borderStyle: "solid",
                        borderRadius: "5px",
                        borderWidth: "1px",
                        height: "34px",
                        marginTop: "11px",
                      }}
                    />
                  ) : (
                    <InstituteAutocomplete
                      onInstituteSelect={(id, name) => {
                        setInstituteId(id);
                        setInstituteName(name || "");
                      }}
                      defaultValue={instituteName}
                      searchIcon={search}
                      placeholder={
                        decode?.clientId ===
                        "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
                          ? "Product Type"
                          : "Merchant Name"
                      }
                    />
                  )}
                </div>
              </Col>
              <Col>
                <div
                  style={{
                    height: "7px",
                    marginRight: "10px",
                    marginLeft: "12px",
                  }}
                >
                  <Datetime
                    closeOnSelect="false"
                    id="fromDate"
                    dateFormat="DD MMM YYYY"
                    timeFormat={false}
                    value={filterDateFrom ? moment(filterDateFrom, "DD MMM YYYY") : ""}
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateFrom(event.format("DD MMM YYYY"));
                      } else {
                        setFilterDateFrom("");
                      }
                    }}
                    locale="en-gb"
                    inputProps={{
                      placeholder: "From Date",
                      style: { fontFamily: "Inter", fontSize: "14px" },
                    }}
                  />
                </div>
              </Col>
              <Col>
                <div
                  style={{
                    height: "7px",
                    marginRight: "10px",
                  }}
                >
                  <Datetime
                    closeOnSelect="false"
                    id="toDate"
                    key={filterDateFrom}
                    dateFormat="DD MMM YYYY"
                    isValidDate={valid}
                    timeFormat={false}
                    locale="en-gb"
                    initialViewDate={
                      filterDateFrom
                        ? moment(filterDateFrom, 'DD MMM YYYY')
                        : moment()
                    }
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateTo(event.format("DD MMM YYYY"));
                      } else {
                        setFilterDateTo("");
                      }
                    }}
                    value={filterDateTo}
                    inputProps={{
                      placeholder: "To Date",
                      style: { fontFamily: "Inter", fontSize: "14px" },
                    }}
                  />
                </div>
              </Col>
              <Col>
                <div>
                  <button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "130px",
                      backgroundColor: "#D22129",
                      height: "34px",
                      borderStyle: "none",
                      borderRadius: "5px",
                      color: "white",
                      fontFamily: "Inter",
                      paddingLeft: "10px",
                    }}
                    onClick={handleSearch}
                  >
                    Search Results
                  </button>
                </div>
              </Col>

              {decode.role === "cra" ||
              decode.role === "crsa" ||
              decode.role === "institute_cra" ||
              (decode.instituteId ===
                "9d5eca4b-54f7-42a7-8794-1413e00b462e" &&
                decode.role === "institute_user") ? (
                ""
              ) : (
                <Col>
                  <button
                    style={{
                      backgroundColor: "#D22129",
                      width: "90px",
                      height: "34px",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "150px",
                      borderStyle: "none",
                      borderRadius: "5px",
                      color: "white",
                      fontFamily: "Inter",
                    }}
                    id="downloadButton"
                    onClick={handleDownloadList}
                  >
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "15px",
                      }}
                    >
                      <img
                        style={{
                          height: "15px",
                          alignItems: "center",
                          marginRight: "5px",
                        }}
                        src={download}
                        alt="download"
                      />
                      <span>Export</span>
                    </p>
                  </button>
                </Col>
              )}
            </div>
          </Row>

          {isLoading ? (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "15%",
                backgroundColor: "white",
                height: "100vh",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <div className="tables" style={{ marginTop: "20px" }}>
                <table>
                  <thead className="table-heading">
                    <tr>
                      <th
                        style={{
                          fontSize: "14px",
                          width: "10em",
                          borderTopLeftRadius: "8px",
                        }}
                        id="appId"
                      >
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            marginLeft: "12px",
                          }}
                        >
                          Appl. Id
                        </span>
                      </th>
                      <th id="appname" style={{ width: "20em" }}>
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            marginLeft: "5px",
                          }}
                        >
                          Appl. Name
                        </span>
                      </th>
                      {(decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user") &&
                      decode.instituteId ===
                        "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? (
                        <th
                          style={{
                            fontSize: "14px",
                            fontFamily: "Inter",
                            width: "10em",
                          }}
                          id="appname"
                        >
                          <span style={{ marginLeft: "10px" }}></span> Student
                          Name
                        </th>
                      ) : null}
                      <th id="insName" style={{ width: "15em" }}>
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            marginLeft: "5px",
                          }}
                        >
                          {decode?.clientId ===
                          "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
                            ? "Product Type"
                            : "Merchant Name"}
                        </span>
                      </th>
                      {decode?.role === "institute_user" ||
                      decode.role === "institute_admin" ||
                      decode.role === "channel_user" ? null : (
                        <th id="cibil" style={{ width: "15em" }}>
                          <span
                            style={{
                              fontFamily: "Inter",
                              fontSize: "14px",
                              marginLeft: "5px",
                            }}
                          >
                            {decode?.clientId ===
                            "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"
                              ? "CRIF"
                              : "CIBIL"}
                          </span>
                        </th>
                      )}
                      <th id="coLenderStatus" style={{ width: "10em" }}>
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            marginLeft: "10px",
                          }}
                        >
                          Status
                        </span>
                      </th>
                      <th id="date" style={{ width: "15em" }}>
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            marginLeft: "10px",
                          }}
                        >
                          Date
                        </span>
                      </th>
                      <th
                        id="amt"
                        style={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          marginLeft: "10px",
                          width: "10em",
                        }}
                      >
                        Amount
                      </th>
                      {decode.role === "institute_user" ||
                      decode.role === "institute_admin" ||
                      decode.role === "user" ||
                      decode.role === "co_lender" ||
                      decode.role === "channel_user"? null : (
                        <th id="actions" style={{ width: "10em" }}>
                          <span
                            style={{
                              fontFamily: "Inter",
                              fontSize: "14px",
                              marginLeft: "10px",
                            }}
                          >
                            Actions
                          </span>
                        </th>
                      )}
                    </tr>
                  </thead>
                  {tableData.map((item, index) => {
                    return (
                      <tbody
                        className="table-body"
                        key={item.applicationId}
                      >
                        <tr
                          className="table-row"
                          style={{ lineHeight: "28px" }}
                        >
                          {decode.role !== "institute_user" &&
                          decode.role !== "institute_admin" &&
                          decode.role !== "channel_user" ? (
                            <td>
                              <span
                                onClick={() =>
                                  handleApplicationProfile(item)
                                }
                                style={{
                                  cursor: "pointer",
                                  fontFamily: "Inter",
                                  fontSize: "14px",
                                  lineHeight:'1.4em',
                                  color:'#667085',
                                }}
                              >
                                {item.applicationId}
                              </span>
                            </td>
                          ) : (
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                fontFamily: "Inter",
                                width: "8em",
                               lineHeight:'1.4em',
                               color:'#667085'
                              }}
                            >
                              {decode.role === "institute_user" &&
                              decode.instituteId ===
                                "9d5eca4b-54f7-42a7-8794-1413e00b462e" ? (
                                <Tooltip
                                  title={
                                    item.studentId
                                      ? item.studentId
                                      : "No StudentId"
                                  }
                                  arrow
                                >
                                  {item.applicationId}
                                </Tooltip>
                              ) : (
                                <>
                                  {item.orderId
                                    ? item.orderId
                                    : item.applicationId}
                                </>
                              )}
                            </td>
                          )}

                          {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? (
                            <td
                              style={{
                                fontSize: "14px",
                                fontFamily: "Inter",
                             lineHeight:'1.4em',
                             color:'#667085',
                                width: "20em",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Inter",
                                  fontWeight: "400",
                                 color:'#667085',
                                  fontSize: "14px",
                                  lineHeight: "1.5em",
                                }}
                              >
                                {item?.name
                                  ?.toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")}
                              </span>
                              <br />
                              {item.coapplicantName ? (
                                <span
                                  style={{
                                    fontFamily: "Inter",
                                    fontWeight: "400",
                                    color: "#101828",
                                    fontSize: "14px",
                                    lineHeight: "2em",
                                  }}
                                >
                                  {item?.coapplicantName
                                    ?.toLowerCase()
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ")}{" "}
                                  ( C )
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                          ) : (
                            <td
                              style={{
                                fontSize: "14px",
                                lineHeight:'1.4em',
                                  color:'#667085',
                                cursor: "pointer",
                                fontFamily: "Inter",
                                width: "20em",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Inter",
                                  marginTop: "10px",
                                  lineHeight: "1.5em",
                                }}
                                onClick={() => handleUser(item)}
                              >
                                {item?.name
                                  ?.toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")}
                                  <span>
                                  {item.panValid === 0 && (
                                    <img
                                      src={alerticon}
                                      alt=""
                                      style={{ maxWidth: '100%', height: 'auto' }}
                                      title='Pan validity indication'
                                    />
                                  )}
                                </span>
                                {item?.bankStatementValid === 0 && (
                                  <Tooltip
                                    title="Bank statement fraud detected"
                                    arrow
                                  >
                                    <WarningIcon
                                      sx={{
                                        color: "#d22129",
                                        fontSize: 16,
                                        ml: 1,
                                      }}
                                    />
                                  </Tooltip>
                                )}
                                {/* {item?.noBankStatement &&
                                  decode?.clientId ===
                                    "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                                    <Tooltip
                                      slotProps={{
                                        tooltip: {
                                          sx: { backgroundColor: "#000" },
                                        },
                                        arrow: {
                                          sx: { color: "#000" },
                                        },
                                      }}
                                      title="Bank statement pending."
                                      arrow
                                    >
                                      <DangerousIcon
                                        sx={{
                                          color: "#d22129",
                                          fontSize: 16,
                                          ml: 1,
                                        }}
                                      />
                                    </Tooltip>
                                  )} */}
                                {item?.noVerification &&
                                  decode?.clientId ===
                                    "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                                    <Tooltip
                                      slotProps={{
                                        tooltip: {
                                          sx: { backgroundColor: "#000" },
                                        },
                                        arrow: {
                                          sx: { color: "#000" },
                                        },
                                      }}
                                      title="Field verification is pending."
                                      arrow
                                    >
                                      <PersonOffIcon
                                        sx={{
                                          color: "#d22129",
                                          fontSize: 16,
                                          ml: 1,
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                {item?.aaValid === 0 && (
                                  <Tooltip
                                    title="Acount Aggregator fraud detected"
                                    arrow
                                  >
                                    <WarningIcon
                                      sx={{
                                        color: "#d22129",
                                        fontSize: 16,
                                        marginLeft: 1,
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </span>
                              <br />
                              {item.coapplicants && (
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignSelf: "center",
                                  }}
                                >
                                  {item?.coapplicants?.map(
                                    (coapp, index) => (
                                      <span
                                        style={{
                                          fontFamily: "Inter",
                                          marginTop: "10px",
                                          lineHeight: "1.5em",
                                        }}
                                        onClick={() =>
                                          handleCoApp(
                                            item,
                                            coapp?.coapplicantId
                                          )
                                        }
                                        key={index}
                                      >
                                        <span>
                                          {coapp?.coapplicantName
                                            ?.toLowerCase()
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" ")}{" "}
                                          (C)
                                        </span>
                                      </span>
                                    )
                                  )}
                                </span>
                              )}
                            </td>
                          )}

                          {(decode.role === "institute_user" ||
                            decode.role === "institute_admin" ||
                            decode.role === "channel_user") &&
                          decode.instituteId ===
                            "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? (
                            <td title={item.studentName}>
                              <span
                                style={{
                                  width: "10em",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  color: "#667085",
                                  fontFamily: "Inter",
                                  display: "block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.studentName ? item.studentName : "-"}
                              </span>
                            </td>
                          ) : null}

                          <td>
                            <div className="merchant-with-source">
                              <span
                                title={item.instituteName}
                                style={{
                                  fontSize: "14px",
                                  maxWidth: "12em",
                                  color: "#667085",
                                  fontFamily: "Inter",
                                  lineHeight: "1.5em",
                                  display: "block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.instituteName}
                              </span>
                              {item.productType === 2 && (
                                <SourceBadge attribution={item.attribution} repeat={item.repeat} />
                              )}
                            </div>
                          </td>

                          {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? null : (
                            <td
                              style={{
                                fontSize: "14px",
                                width: "6em",
                                color:
                                  (item.fundSourceCode !== "GBP" &&
                                  decode?.clientId !==
                                    "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && item.productType !== 2)
                                    ? "black"
                                    : "blue",
                                cursor: "pointer",
                                fontFamily: "Inter",
                              }}
                            >
                              {(item.fundSourceCode !== "GBP" &&
                              decode?.clientId !==
                                "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && item.productType !== 2 )? (
                                <span style={{ lineHeight:'1.4em',
                                  color:'#667085'}}>NA<br /></span>
                              ) : item.applicantCibil !== "Error" ? (
                                <span
                                  style={{
                                    fontFamily: "Inter",
                                    fontSize: "14px",
                                    
                                  }}
                                  onClick={() => handleCIBIL(item)}
                                >
                                  {item.applicantCibil}
                                </span>
                              ) : (
                                <span
                                  onClick={() =>
                                    showErrorApplicant(
                                      item.userId,
                                      item.applicationId,
                                      item
                                    )
                                  }
                                >
                                  Error
                                </span>
                              )}

                              {item.coapplicants
                                ? item?.coapplicants?.map(
                                    (coapp, index) =>
                                      item.fundSourceCode !== "GBP" &&
                                      decode?.clientId !==
                                        "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ? (
                                        <span  style={{ lineHeight:'1.4em',
                                  color:'#667085'}} key={index}>NA</span>
                                      ) : item.coapplicantCibil !==
                                        "Error" ? (
                                        <span
                                          style={{
                                            fontFamily: "Inter",
                                            fontSize: "14px",
                                          }}
                                          key={index}
                                          onClick={() =>
                                            handleCoAppCIBIL(
                                              item,
                                              coapp?.coapplicantId
                                            )
                                          }
                                        >
                                          <br />
                                          {coapp.coapplicantCibil}
                                        </span>
                                      ) : (
                                        <span
                                          onClick={() =>
                                            showErrorCoApplicant(
                                              item.coapplicantId,
                                              item.applicationId,
                                              item
                                            )
                                          }
                                          key={index}
                                        >
                                          Error
                                        </span>
                                      )
                                  )
                                : ""}
                            </td>
                          )}

                          <td
                            style={{
                              fontSize: "14px",
                              cursor: "pointer",
                              width: "7em",
                              lineHeight:'1.4em',
                                  color:'#667085',
                              fontFamily: "Inter",
                            }}
                          >
                            <span
                              className={`${item.fundSourceCode}-text`}
                            >
                              {item.fileStatus
                                ? item.fileStatus
                                    .substr(0, 1)
                                    .toUpperCase() +
                                  item.fileStatus
                                    .substr(1, item.fileStatus.length)
                                    .toLowerCase()
                                : "In Process"}
                            </span>
                          </td>
                          <td
                            style={{
                              fontSize: "14px",
                              cursor: "pointer",
                              width: "9em",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {item.appliedDate?.substr(0, 10)
                              ? moment(
                                  item?.appliedDate?.substr(0, 10)
                                ).format("DD MMM YY")
                              : "-"}
                          </td>
                          <td
                            style={{
                              width: "7em",
                              fontSize: "14px",
                              color: "#667085",
                              fontFamily: "Inter",
                            }}
                          >
                            {item.courseFees ? (
                              <>
                                &#8377;
                                {formatNumberWithCommas(
                                  item.courseFees
                                )}
                              </>
                            ) : (
                              "-"
                            )}
                          </td>

                          {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "user" ||
                          decode.role === "co_lender" ||
                          decode.role === "channel_user" ? null : (
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                {decode?.role!=='exec' && <span
                                  title="Edit Form"
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "10px",
                                  }}
                                >
                                  <EditForm curruser={item} />
                                </span>}
                                <span
                                  title="Move Status"
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "0.3vw",
                                  }}
                                >
                                  <MoveProcessingStatus
                                    ApplicantId={item}
                                  />
                                </span>
                                {fundSourceSelected !== "FIB" && (
                                  <span
                                    title="Request Bank Statement"
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "0.3vw",
                                    }}
                                  >
                                    <SendSms ApplicantId={item} />
                                  </span>
                                )}
                                {isFibInfoVisible && (
                                  <span
                                    title="Info"
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "0.3vw",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={() => handleFibInfoClick(item)}
                                  >
                                    <InfoOutlinedIcon
                                      sx={{ color: "#000000", fontSize: 22 }}
                                    />
                                  </span>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>

              {totalFetchRows ? (
                totalFetchRows <= 100 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontFamily: "Inter",
                        fontSize: "1vw",
                        marginLeft: "10px",
                        marginBottom: "5px",
                      }}
                    >
                      Showing{" "}
                      {currentPage * rowsPerPage + 1 - rowsPerPage}-
                      {currentPage * rowsPerPage -
                        rowsPerPage +
                        tableData?.length}{" "}
                      records of {totalFetchRows} |
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      &nbsp;
                      <p style={{ fontWeight: "600" }}>
                        Rows Per Pages :
                      </p>
                      <div>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(15)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 15 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 15 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          15
                        </span>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(50)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 50 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 50 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          50
                        </span>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(100)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 100 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 100 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          100
                        </span>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(500)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 500 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 500 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          500
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        justifyContent: "space-between",
                        fontFamily: "Inter-Medium",
                        fontSize: "1vw",
                        marginLeft: "10px",
                        marginBottom: "5px",
                        marginRight: "10px",
                      }}
                    >
                      Showing{" "}
                      {currentPage * rowsPerPage + 1 - rowsPerPage}-
                      {currentPage * rowsPerPage -
                        rowsPerPage +
                        tableData?.length}{" "}
                      records of {totalFetchRows} |
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p style={{ fontWeight: "600" }}>
                        Rows Per Pages :
                      </p>
                      <div>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(15)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 15 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 15 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          15
                        </span>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(50)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 50 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 50 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          50
                        </span>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(100)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 100 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 100 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          100
                        </span>
                        <span
                          onClick={() =>
                            handleRowsPerPageChange(500)
                          }
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            color:
                              activePage === 500 ? "#D32028" : "black",
                            backgroundColor:
                              activePage === 500 ? "#FFF2F3" : "",
                            borderRadius: "8px",
                          }}
                        >
                          500
                        </span>
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontFamily: "Inter",
                    fontSize: "14px",
                  }}
                >
                  No Records
                </div>
              )}

              <PaginationTable
                startPage={currentPage}
                rowsPerPage={rowsPerPage}
                totalRows={totalFetchRows}
                paginate={paginate}
                handlepageChange={handlepageChangeLocal}
                filterDateFrom={filterDateFrom}
              />
            </>
          )}
        </CardBody>
    </Card>

    <Modal isOpen={fibInfoModalOpen} toggle={toggleFibInfoModal} centered>
      <ModalHeader toggle={toggleFibInfoModal}>Available Tenures</ModalHeader>
      <ModalBody>
        {fibInfoLoading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
            <CircularProgress size={24} />
          </div>
        ) : fibTenureData?.length > 0 ? (
          <table style={{ width: "100%", textAlign: "left" }}>
            <thead>
              <tr>
                <th style={{ paddingBottom: "8px" }}>Tenure</th>
                <th style={{ paddingBottom: "8px" }}>Available Limit</th>
              </tr>
            </thead>
            <tbody>
              {fibTenureData.map((tenureItem, index) => (
                <tr key={index}>
                  <td style={{ padding: "4px 0" }}>{tenureItem?.productName}</td>
                  <td style={{ padding: "4px 0" }}>
                    {tenureItem?.customerAvailableLimit}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div style={{ textAlign: "center", padding: "10px" }}>
            Data not yet available
          </div>
        )}
      </ModalBody>
    </Modal>
    </>
  );
};

export default ProcessingTable;
